import { NavLink } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";

interface BreadCrumbProps {
    title: string
    links: string
    actionName: string
}

function BreadCrumb(props: BreadCrumbProps) {
    const { title, links, actionName } = props;
    const { theme } = useTheme();
    const isLightMode = theme === "light";

    return (
        <header className="d-flex justify-content-between align-items-center py-3 px-0">
            <h1
                className="h4 mb-0"
                style={{ color: isLightMode ? "#111827" : "#E8E6E0" }}
            >
                {title}
            </h1>
            <NavLink
                to={links}
                className="border-0"
                style={{ color: isLightMode ? "#b42318" : "#dc3545" }}
            >
                {actionName}
            </NavLink>
        </header>
    )
}

export default BreadCrumb;  